import { render, staticRenderFns } from "./sub-task-details.vue?vue&type=template&id=db2289d4&scoped=true&"
import script from "./sub-task-details.vue?vue&type=script&lang=js&"
export * from "./sub-task-details.vue?vue&type=script&lang=js&"
import style0 from "./sub-task-details.vue?vue&type=style&index=0&id=db2289d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2289d4",
  null
  
)

export default component.exports